// extracted by mini-css-extract-plugin
export default {"container":"CustomerProfile_container__htQ4V","infoGrid":"CustomerProfile_infoGrid__WVLs+","version":"CustomerProfile_version__U3sQH"};